import axios from "axios";
import { DocumentClassification } from "@/api/documentClassification";

export type SharedDocument = {
    documentRef: string,
    name: string,
    mimeType: string | null,
    sizeByte?: number,
    uploadedAtUtc: Date
    imageGallery?: boolean
    documentClassification: DocumentClassification | null
}

interface SharedDocumentApi {
    listDocuments(): Promise<SharedDocument[]>;

    add(file: File): Promise<string>;

    editDocument(sharedDocument: SharedDocument): Promise<void>;

    deleteDocument(sharedDocument: SharedDocument): Promise<void>;

    generateDownloadLink(sharedDocument: SharedDocument): string;
}

export const sharedDocumentApi: SharedDocumentApi = {

    async listDocuments() {
        const result = (await axios.get(`/api/shared-documents`))
            .data as SharedDocument[];
        if (result) {
            return result.map(
                (v) =>
                    ({
                        ...v,
                        uploadedAtUtc: v.uploadedAtUtc ? new Date(v.uploadedAtUtc) : null,
                    } as SharedDocument)
            );
        }
        return [];
    },

    async add(file) {
        const formData = new FormData();
        formData.append("file", file);
        return (await axios.post(`/api/shared-documents`, formData)).data;
    },

    async deleteDocument(sharedDocument) {
        return await axios.delete(`/api/shared-documents/${sharedDocument.documentRef}`);
    },

    generateDownloadLink(sharedDocument): string {
        return `/api/shared-documents/${sharedDocument.name}`;
    },

    async editDocument(sharedDocument) {
        await axios.put(
            `/api/shared-documents/${sharedDocument.documentRef}`,
              sharedDocument,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
    },
};
